/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { newDesignConfigSchema } from "./newDesignConfigSchema.ts";

export const orgOrganizationsDesignRetrievePathOrgIdSchema = z.uuid();

export const orgOrganizationsDesignRetrieveStatus200Schema = newDesignConfigSchema;

export const orgOrganizationsDesignRetrieveResponseSchema = orgOrganizationsDesignRetrieveStatus200Schema;
